import React from 'react';
import { useChangelogs } from '@/hooks/supabase/useChangelogs';
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import ReactMarkdown from 'react-markdown';
import { format } from 'date-fns';
import remarkGfm from 'remark-gfm';

const ChangelogPage = () => {
  const { changelogs, loading, error } = useChangelogs();

  const renderContent = () => {
    if (loading) {
      return (
        <div className="space-y-8">
          {[...Array(3)].map((_, i) => (
            <Card key={i}>
              <CardHeader>
                <Skeleton className="h-8 w-1/4" />
                <Skeleton className="h-4 w-1/2" />
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-full" />
                  <Skeleton className="h-4 w-3/4" />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      );
    }

    if (error) {
      return <p className="text-red-500">Error loading changelog: {error.message}</p>;
    }

    if (!changelogs || changelogs.length === 0) {
      return <p>No changelog entries found.</p>;
    }

    return (
      <div className="space-y-8">
        {changelogs.map((log) => (
          <Card key={log.id}>
            <CardHeader>
              <CardTitle className="text-2xl">Version {log.version}</CardTitle>
              <p className="text-sm text-muted-foreground">
                Released on {format(new Date(log.release_date), 'MMMM d, yyyy')}
              </p>
            </CardHeader>
            <CardContent>
              <div className="prose dark:prose-invert max-w-none">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{log.notes}</ReactMarkdown>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  };

  return (
    <MainLayout>
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">Changelog</h1>
        {renderContent()}
      </div>
    </MainLayout>
  );
};

export default ChangelogPage;